/**
 * 下载apk
 */

import Supporter from '../utils/supporter';
import SohuStat from '../statistics/sohu-stat'
import CallApp from './call-app.js';

export default {
    isActivity: true,
    apkDownloadLink: 'https://statics.itc.cn/lt-app/sohumobile_official_gray_optimizeRelease_4_1.0.3_01161850.apk',
    huaweiMarketLink: 'hiapp://com.huawei.appmarket?activityName=activityUri|appdetail.activity&params={"params":[{"name":"uri","type":"String","value":"app|C100122117"}]}&channelId=123412',
    apkDownloadLinkMap: {
        android: {
            // 首页放到桌面icon点击
            msohu_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_official_gray_optimizeRelease_4_1.0.3_01161850.apk',
            mchanel_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_sohumobile_put_desk_channel.apk',
            mdetail_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_detail.apk',
            msubchanel_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_sub_channel.apk',
            mauthor_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_author_page.apk',
            // 新闻评论页放到桌面icon点击
            mnewscom_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_news_comments.apk',
            // 组图评论页放到桌面icon点击
            mpicscom_putDesk: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_pics_comments.apk',
            mdetail_banner: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_detail_banner.apk',
            msohu_float: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_main_float.apk',
            msohu_popwindow: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_main_popwindow.apk',
            // 淘宝双十一长文下的按钮
            mdetail_btn: 'https://statics.itc.cn/lt-app/sohumobile_put_desk_detail_button.apk',
            //广告位大图点击放到桌面上
            calendar_putDesk:'https://statics.itc.cn/lt-app/sohumobile_perpetual_calendar.apk'
        },
        ios: {
            // mdetail_btn: 'https://itunes.apple.com/app/apple-store/id1395095395?pt=118499494&ct=detail_button&mt=8',
            other: 'https://itunes.apple.com/cn/app/%E6%90%9C%E7%8B%90%E7%BD%91/id1395095395'
        }
    },
    appProtocol:  {
        intent: 'intent://com.sohu.mobile/main?wake_up=mobile_sohu#Intent;scheme=sohu;package=com.sohu.mobile;end',
        iosSchema: 'sohuMobile://',
        androidSchema: 'sohu://com.sohu.mobile/main?wake_up=mobile_sohu',
        universalLink: 'https://v2.sohu.com/applinks/app.html',
        yingyongbao: '//a.app.qq.com/o/simple.jsp?pkgname=com.sohu.mobile'
    },
    downloadApk: function(actionId, appDownType) {
        const ios = !!Supporter.os.ios,
            android = !!Supporter.os.android;

        var downloadUrl = '404.html';
        appDownType = appDownType || 'msohu_putDesk';

        (ios) && (downloadUrl = this.apkDownloadLinkMap.ios.other);
        (android) && (downloadUrl = this.apkDownloadLinkMap.android[appDownType]);
        if(actionId) {
            SohuStat.sendActionStat(actionId);
        }

        // 唤起app
        new CallApp({
            protocol:  {
                intent: this.appProtocol.intent,
                schema: Supporter.os.ios ? this.appProtocol.iosSchema : this.appProtocol.androidSchema,
                universalLink: this.appProtocol.universalLink,
                yingyongbao: this.appProtocol.yingyongbao
            },
            fail () {
                window.location = downloadUrl;
            }
        }).call();
    },
    avokeAPK: function(actionId, url) {
        if(actionId){
            SohuStat.sendActionStat(actionId);
        }
        if(url) {
            window.location.href = 'msohu://m.sohu.com:80/path?url=' + url;
        }else {
            window.location.href = 'msohu://m.sohu.com';
        }
    }
}